import React, { useContext, useEffect, useState } from "react";
import { Label } from "../../../../../../stories/Label/Label";
import Input from "../../../../../../stories/Input/Input";
import { LabelProps, msgType } from "../../../../../../utils/types";
import ItemSelect from "../../../../../../customComponents/ItemSelect";
import {
  AtsStckItem,
  ItemQueryType,
} from "../../../masters/items/queries/types";
import { TextField } from "@mui/material";
import { emptyFunc, emptyMessage } from "../../../../../../utils/constants";
import { itmType } from "../../material/statesProvider/materialContext";
import { StockEntryContext } from "./context/context";
import { stockEntryPayLoadTypes } from "./context/reducer";
import useServerDateandTime from "../../../../../../customHooks/useServerDateandTime";
import {
  CustomModal,
  toStandardDate,
} from "../../../../../../utils/UtilFunctions";

import MoreInfo from "../../../../../../images/MoreInfo.svg";
import ViewAsset from "../ViewAsset";
import { ViewModalStyles } from "../../../../../../styles/CustomModalStyles";
import SuppliersSelect from "../../purchaseorder/rfqtopo/components/SuppliersSelect";
import {
  responseType,
  StockEntryItem,
} from "../../../../../../utils/formTypes";
import { useLazyQuery } from "@apollo/client";
import { GetItemNodeForStockEntry } from "../../../masters/items/queries/queries";
import { nodeVar } from "../../../../../../utils/commonQueryTypes";

import MessageModal from "../../../../../../customComponents/MessageModal";
import { Operation } from "../../../../../../utils/Enum.types";
import SupplierForm from "./SupplierForm";
import useLabels from "../../../../../../customHooks/useLabels";
import useFormJson from "../../../../../../json/useFormJson";

const ItemForm = () => {
  const { dispatch, state } = useContext(StockEntryContext);

  const [viewAsset, setViewAsset] = useState(false);

  const [message, setMessage] = useState<msgType>(emptyMessage);

  const { serverDate } = useServerDateandTime();
  const { StockEntry } = useFormJson();
  const itemInitialValues = {
    description: "",
    uom: "",
    category: "",
    sub_category: "",
    manufacturer: "",
  };
  const [itemFormData, setItemFormData] =
    useState<StockEntryItem>(itemInitialValues);


  const [GetItem, { data }] = useLazyQuery<{ node: AtsStckItem }, nodeVar>(
    GetItemNodeForStockEntry
  );

  const onItemSelect = (newValue: itmType) => {
    if (newValue) {
      dispatch({
        type: stockEntryPayLoadTypes.ITEM,
        payload: {
          itm: newValue,
        },
      });
    } else {
      dispatch({
        type: stockEntryPayLoadTypes.ITEM,
        payload: {
          itm: null,
        },
      });
    }
  };

  useEffect(() => {
    if (state.itm) {
      GetItem({
        variables: {
          id: state.itm.value,
      
        },
      }).then(({ data }) => {
        if (data && data) {
          const { desc, categoryDetails, uom, manufacturerDetails } =
            data.node;

          setItemFormData({
            description: desc,
            category: categoryDetails.categoryName,
            uom,
            sub_category: "",
            manufacturer: manufacturerDetails.manufacturer,
          });
        }
      });
    } else {
      setItemFormData({
        description: "",
        uom: "",
        category: "",
        sub_category: "",
        manufacturer: "",
      });
    }
  }, [GetItem, state.itm, data]);

  const { itemLabel } = useLabels();

  return (
    <>
      <div className="add-stock-entry__header row g-0">
        <div className="col label-grid">
          <Label>Reference No.</Label>
          <Input disabled />
        </div>
        <div className="col flex-end">
          <div className="label-grid">
            <Label>Date</Label>
            <Input
              disabled
              value={toStandardDate(new Date(serverDate).toString())}
            />
          </div>
        </div>
      </div>
      <div className="add-stock-entry__select row g-0">
        <div className="col add-stock-entry__select--grid">
          {StockEntry.WithoutPurchase.ItemDetails.map(
            (label: LabelProps, index: React.Key) => {
              if (label.inputName === "code") {
                return (
                  <div className="add-stock-entry__select--flex" key={index}>
                    <ItemSelect
                      onChange={onItemSelect}
                      onKeyDown={emptyFunc}
                      value={state.itm ? state.itm.value : 0}
                      label={`Select ${itemLabel}`}
                      autoFocus
                      placeholder=""
                    />
                  </div>
                );
              } else if (label.inputName === "description") {
                return (
                  <div className="add-stock-entry__select--flex" key={index}>
                    <TextField
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      label={label.labelName}
                      value={itemFormData[label.inputName]}
                      className="add-stock-entry__select--textfield"
                      disabled
                    />
                    <img
                      src={MoreInfo}
                      alt=""
                      onClick={() => {
                        if (state.itm) setViewAsset(!viewAsset);
                        else
                          setMessage({
                            message: "Please select an item",
                            flag: true,
                            operation: Operation.NONE,
                          });
                      }}
                    />
                  </div>
                );
              } else
                return (
                  <React.Fragment key={index}>
                    <TextField
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      label={label.labelName}
                      value={itemFormData[label.inputName]}
                      className="add-stock-entry__select--textfield"
                      disabled
                    />
                  </React.Fragment>
                );
            }
          )}
        </div>
        <SupplierForm />
      </div>

      <CustomModal
        isOpen={viewAsset}
        onRequestClose={() => setViewAsset(!viewAsset)}
        contentComponent={<ViewAsset setModalFlag={setViewAsset} itemId={0} />}
        style={ViewModalStyles}
      />
      <MessageModal
        handleClose={() => setMessage(emptyMessage)}
        modalFlag={message.flag}
        value={message.message}
        operation={message.operation}
      />
    </>
  );
};

export default ItemForm;
